import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiHttp } from './services/ui-http/ui-http.service';
import { LoadingService } from './services/ui-http/loading.service';
import { UserService } from './services/user/user.service';
import { CapitalizePipe } from './pipes/capitalize/capitalize.pipe';
import { ExcludePipe } from './pipes/exclude/exclude.pipe';
import { KeysPipe } from './pipes/keys/keys.pipe';
import { PbiReportComponent } from './components/pbi-report/pbi-report.component';
import { EllipsisPipe } from './pipes/ellipsis/ellipsis.pipe';
import { MiddleEllipsisPipe } from './pipes/middle-ellipsis/middle-ellipsis.pipe';
import { SendEmailDialogComponent } from './components/send-email-dialog/send-email-dialog.component';
import { SendEmailDialogService } from './services/send-email-dialog.service';
import { ContentEditDialogService } from './services/content-edit-dialog.service';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { ContentEditDialogComponent } from './components/content-edit-dialog/content-edit-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FroalaEditorComponent } from './components/froala-editor/froala-editor.component';
import { NgLetDirective } from '@shared/directives/ng-let.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BannerComponent } from '@shared/components/banner/banner.component';
import { BoldPipe } from '@shared/pipes/bold/bold.pipe';
import { SendPhoneDialogService } from '@shared/services/send-phone-dialog.service';
import { SendPhoneDialogComponent } from '@shared/components/send-phone-dialog/send-phone-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditLanguagesDialogComponent } from '@shared/components/edit-languages-dialog/edit-languages-dialog.component';

@NgModule({
    declarations: [
        ExcludePipe,
        CapitalizePipe,
        PbiReportComponent,
        SendEmailDialogComponent,
        SendPhoneDialogComponent,
        ContentEditDialogComponent,
        FroalaEditorComponent,
        NgLetDirective,
        NgLetDirective,
    ],
  imports: [
    CommonModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatRadioModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    MatCheckboxModule,
    MatTooltipModule,
    MiddleEllipsisPipe,
    EllipsisPipe,
    BoldPipe,
    BannerComponent,
    KeysPipe,

    EditLanguagesDialogComponent,
  ],
    providers: [
        UiHttp,
        LoadingService,
        SendEmailDialogService,
        SendPhoneDialogService,
        ContentEditDialogService,
    ],
    exports: [
        KeysPipe,
        ExcludePipe,
        CapitalizePipe,
        PbiReportComponent,
        EllipsisPipe,
        MiddleEllipsisPipe,
        SendEmailDialogComponent,
        SendPhoneDialogComponent,
        ContentEditDialogComponent,
        FroalaEditorComponent,
        NgLetDirective,
        BannerComponent,
        BoldPipe,
    ]
})
export class UiSharedModule {
  static forRoot(): ModuleWithProviders<UiSharedModule> {
    return {
        ngModule: UiSharedModule,
        providers: [UserService],
    };
}
}
